module.exports = __webpack_public_path__ + "static/media/BMON.91df527f.svg";